/* eslint-disable max-lines */
import { css } from 'linaria';

export const accessoriesList = css`
  display: grid;
  grid-template-columns: 280px 580px 280px;
  padding: 0;
  margin: 0;
  column-gap: 20px;
  list-style: none;

  @media (--only-desktop) {
    grid-template-columns: 223px 462px 223px;
    column-gap: 16px;
  }

  @media (--only-tablet) {
    grid-template-columns: 157px 323px 157px;
    column-gap: 11px;
  }

  @media (--only-mobile) {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 142px 142px;
    column-gap: 12px;
    row-gap: 16px;
  }
`;

export const accessoriesLinkItem = css`
  position: relative;
  display: flex;
  flex-direction: column;
  height: 100%;
  color: inherit;
`;

export const basketsAndAccessories = css`
  align-items: center;
  overflow: hidden;
  border: 2px solid #ced0d6;
  border-radius: var(--rounding-m);

  &::before {
    position: absolute;
    top: -55px;
    right: -36px;
    width: 254px;
    height: 254px;
    background-image: linear-gradient(228.43deg, #e8ebba 14.28%, #abd4ee 97.09%);
    border-radius: 50%;
    content: '';

    @media (--only-desktop) {
      top: -43.89px;
      right: -28.67px;
      width: 187px;
      height: 188px;
    }

    @media (--only-tablet) {
      top: -37.85px;
      right: -17.19px;
      width: 132px;
      height: 132px;
    }

    @media (--only-mobile) {
      top: -34px;
      right: -15.17px;
      width: 113px;
      height: 114px;
    }
  }
`;

export const basketsAndAccessoriesName = css`
  padding-top: 235px;
  padding-bottom: 22px;

  @media (--only-desktop) {
    width: 175px;
    padding-top: 159px;
    padding-bottom: 14px;
  }

  @media (--to-desktop) {
    width: 112px;
    padding-top: 99px;
    padding-bottom: 12px;

    && {
      font-size: 16px;
      line-height: 22px;
    }
  }

  @media (--only-mobile) {
    padding-top: 84px;
    padding-bottom: 10px;
  }
`;

export const basketsAndAccessoriesImage = css`
  position: absolute;
  top: 41px;
  right: 30px;
  z-index: 2;
  display: inline-block;
  width: 222px;
  height: 148px;

  @media (--only-desktop) {
    top: 27px;
    right: 20px;
    width: 164px;
    height: 110px;
  }

  @media (--only-tablet) {
    top: 12px;
    right: 17px;
    width: 115px;
    height: 77px;
  }

  @media (--only-mobile) {
    top: 9px;
    right: 14px;
    width: 99px;
    height: 67px;
  }
`;

export const storageBoxesItem = css`
  @media (--only-mobile) {
    grid-column: 1 / -1;
  }
`;

export const storageBoxes = css`
  padding: 40px;
  background-image: linear-gradient(225deg, #bbdbf1, #eae9a5 97.58%);
  border-radius: 3px;
  mix-blend-mode: normal;

  @media (--only-desktop) {
    padding: 32px;
  }

  @media (--to-desktop) {
    padding: 16px;
  }

  &::before {
    position: absolute;
    top: 56px;
    right: 25px;
    width: 258px;
    height: 210px;
    background-image: url("https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/accessories/2.png/2.png");
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    content: '';

    @media (--only-desktop) {
      top: 57px;
      right: 20px;
      width: 198px;
      height: 159px;
    }

    @media (--only-tablet) {
      top: 46px;
      right: 8px;
      width: 138px;
      height: 107px;
    }

    @media (--only-mobile) {
      top: 65px;
      right: -4px;
      width: 144px;
      height: 115px;
    }
  }
`;

export const storageBoxesName = css`
  && {
    margin-bottom: 8px;

    @media (--to-desktop) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (--only-mobile) {
      margin-bottom: 2px;
    }
  }
`;

export const storageBoxesDescription = css`
  margin-bottom: 95px;

  @media (--only-desktop) {
    margin-bottom: 53px;
  }

  @media (--only-tablet) {
    margin-bottom: 35px;

    && {
      font-size: 14px;
      line-height: 20px;
    }
  }

  @media (--only-mobile) {
    margin-bottom: 23px;
  }
`;

export const storageBoxesSeeButton = css`
  && {
    width: 223px;
    border: 2px solid #999;

    @media (--only-desktop) {
      width: 169px;
    }

    @media (--only-tablet) {
      width: 135px;
      padding: 8px 18px;
      font-size: 16px;
      line-height: 24px;
    }

    @media (--only-mobile) {
      width: 125px;
      height: 40px;
      padding: 6px 14px;
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const sectionName = css`
  margin-bottom: 40px;

  @media (--to-desktop) {
    margin-bottom: 32px;
  }

  @media (--only-mobile) {
    margin-bottom: 58px;
  }
`;

export const shelves = css`
  box-sizing: border-box;
  padding: 24px 50px 0 24px;
  overflow: hidden;
  border: 2px solid #ced0d6;
  border-radius: 4px;

  @media (--only-desktop) {
    padding: 16px 24px 0;
  }

  @media (--only-tablet) {
    padding: 16px 16px 0;
  }

  @media (--only-mobile) {
    padding: 11px 7px 0 10px;
  }

  &::before {
    position: absolute;
    right: -36px;
    bottom: -103px;
    width: 292px;
    height: 292px;
    background-image: linear-gradient(228.43deg, #e8ebba 14.28%, #abd4ee 97.09%);
    border-radius: 50%;
    transform: matrix(-1, 0, 0, 1, 0, 0);
    content: '';

    @media (--only-desktop) {
      right: -28.67px;
      bottom: -84.27px;
      width: 219px;
      height: 219px;
    }

    @media (--only-tablet) {
      right: -20.9px;
      bottom: -72.67px;
      width: 154px;
      height: 154px;
    }

    @media (--only-mobile) {
      right: -18px;
      bottom: -68px;
      width: 132px;
      height: 132px;
    }
  }
`;

export const shelvesName = css`
  width: 100%;
  @media (--to-desktop) {
    && {
      font-size: 16px;
      line-height: 22px;
    }
  }
`;

export const shelvesImage = css`
  position: relative;
  top: 0;
  right: -36px;
  z-index: 2;
  order: 2;
  width: 180px;
  height: 195px;
  margin-top: auto;
  margin-left: auto;

  @media (--only-desktop) {
    position: absolute;
    top: 89px;
    right: 6px;
    width: 135px;
    height: 140px;
  }

  @media (--only-tablet) {
    position: absolute;
    top: 77px;
    right: 4px;
    width: 95px;
    height: 108px;
  }

  @media (--only-mobile) {
    position: absolute;
    top: 76px;
    right: 2px;
    width: 82px;
    height: 89px;
  }
`;
